<template>
    <router-link class="card kanban-card text-dark text-decoration-none shadow-sm"
                 v-bind:id="task._id"
                 v-bind:to="`/tasks/kanban/${ task._id }`">
        <div class="card-header p-1">
            {{ createdAt }}
        </div>

        <div class="border-bottom p-2">
            <h5 class="font-noto-serif-tc font-weight-bolder mb-0">
                {{ task.title }}
            </h5>
        </div>

        <div class="d-flex align-items-center border-bottom p-2"
             v-if="type === 'service'">
            <div class="mr-2">
                <img class="service-thumbnail"
                     v-bind:alt="serviceName"
                     v-bind:src="`${ $config.apiUrl }/${ $config.apiVersion }/service/image/${ servicePhoto }`">
            </div>
            <div class="flex-grow-1">
                <h6 class="font-weight-bold mb-0">
                    {{ serviceName }}
                </h6>
                <p class="mb-0">
                    <small>
                        {{ skuSelected ? skuSelected.name : "" }} {{ skuSelected ? `(${ skuSelected.code })` : "" }}
                    </small>
                </p>
            </div>
        </div>

        <div class="border-bottom p-2">
            <h6 class="font-weight-bolder mb-0">
                {{ site.siteName }}
            </h6>
            <p class="mb-0">
                <small>
                    {{ site.address }}
                </small>
            </p>
        </div>

        <div class="d-flex flex-nowrap text-dark border-bottom p-2">
            <div class="text-center flex-grow-1">
                <font-awesome-icon class="mr-2"
                                   icon="clipboard-check">
                </font-awesome-icon>
                {{ tasksDone }}
            </div>
            <div class="text-center flex-grow-1">
                <font-awesome-icon class="mr-2"
                                   icon="clipboard-list">
                </font-awesome-icon>
                {{ tasksPending }}
            </div>
        </div>

        <div class="d-flex align-items-center p-2">
            <div class="mr-2">
                <b-avatar size="2.5em"
                          variant="light"
                          v-bind:src="avatar">
                    <font-awesome-icon class="h-100 w-100 p-3"
                                       icon="user-tie"
                                       v-if="!avatar && owner.role === 'vending-admin'">
                    </font-awesome-icon>
                    <font-awesome-icon class="h-100 w-100 p-3"
                                       icon="user-hard-hat"
                                       v-if="!avatar && owner.role === 'vending-site-manager'">
                    </font-awesome-icon>
                </b-avatar>
            </div>
            <div class="flex-grow-1">
                <h6 class="font-weight-bold mb-0">
                    {{ owner.name }}
                </h6>
                <p class="mb-0">
                    <small>
                        {{ owner.email }}
                    </small>
                </p>
            </div>
        </div>
    </router-link>
</template>

<script>
import {
    DefaultMapCenter,
} from "../../../config";

import format from "date-fns/format";
import { zhTW, } from "date-fns/locale";

import { BAvatar, } from "bootstrap-vue";

export default {
    name: "KanbanCard",
    components: {
        BAvatar,
    },
    props: {
        "task": {
            type: Object,
            required: true,
        },
    },
    data () {
        return {
            defaultMapType: "roadmap",
            defaultMapOptions: {
                "zoomControl": false,
                "mapTypeControl": false,
                "scaleControl": false,
                "streetViewControl": false,
                "rotateControl": false,
                "fullscreenControl": false,
                "disableDefaultUi": true,
            },

            isMapOpen: false,
        };
    },
    computed: {
        type () {
            return this.task?.type ?? "";
        },
        site () {
            return this.task?.site ?? { "coordinate": DefaultMapCenter }
        },
        owner () {
            return this.task?.owner ?? null
        },
        avatar () {
            return this.owner ?
                `${ this.$config.apiUrl }/${ this.$config.apiVersion }/user/avatar/${ this.owner.avatar }` :
                "";
        },
        service () {
            return this.task?.service ?? null;
        },
        serviceName () {
            return this.service?.name ?? "";
        },
        servicePhoto () {
            if (this.service) {
                return this.service.photo[0];
            }
            return "";
        },
        skuSelected () {
            if (
                this.service &&
                this.task.sku
            ) {
                const target = this.service.sku
                    .find(
                        ({ _id }) => _id === this.task.sku
                    );
                if (target) {
                    return target;
                }
                return null;
            }
            return null;
        },
        createdAt () {
            return format(
                new Date(this.task.createdAt),
                "PPP p",
                {
                    "locale": zhTW,
                }
            );
        },
        tasks () {
            if (Array.isArray(this.task.tasks)) {
                return this.task.tasks;
            }
            return [];
        },
        tasksDone () {
            return this.tasks
                .reduce(
                    (acc, { isDone }) => {
                        acc += isDone ? 1 : 0
                        return acc;
                    },
                    0
                );
        },
        tasksPending () {
            return this.tasks
                .reduce(
                    (acc, { isDone }) => {
                        acc += isDone ? 0 : 1
                        return acc;
                    },
                    0
                );
        },
    },
    methods: {

    },
}
</script>

<style lang="scss" scoped>
.kanban-card {
    user-select: none;
    transition:
        transform 200ms ease-in-out,
        box-shadow 200ms ease-in-out;

    &:hover,
    &:active {
        transform: scale(1.02);
        box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important;
    }

    .card-header {
        font-size: 0.85rem;
        font-weight: bolder;
    }

    .map {
        height: 100px;
        pointer-events: none;
    }

    .service-thumbnail {
        height: 70px;
        width: 70px;
        object-fit: cover;
    }
}
</style>
